import throttle from 'lodash.throttle'
const sizes = ['xxs', 'xs', 'sm', 'md', 'lg', 'xl']
export default {
  data: {
    currentSize: 'xs',
    windowWidth: 0,
  },
  computed: {
    // helpers for set sizes
    isSmallViewport () {
      return this.currentSizeLte('sm')
    },
    isMediumViewport () {
      return this.currentSizeEquals('md')
    },
    isLargeViewport () {
      return this.currentSizeGte('lg')
    }
  },
  mounted () {

    this.setCurrentViewportSize()

    setTimeout(() => {
      // Some components (inview) needs a scroll event to fire to trigger correct layout
      window.dispatchEvent(new CustomEvent('scroll'))
    }, 1000)

    window.addEventListener("resize", throttle(() => {
      this.setCurrentViewportSize()
    }, 100))
  },
  methods: {
    // current size is Less than or equal to
    currentSizeLte (size) {
      return sizes.indexOf(this.currentSize) <= sizes.indexOf(size)
    },
    // current size is Greater than or equal to
    currentSizeGte (size) {
      return sizes.indexOf(this.currentSize) >= sizes.indexOf(size)
    },
    // current size is Equal to
    currentSizeEquals (size) {
      return sizes.indexOf(this.currentSize) === sizes.indexOf(size)
    },
    setCurrentViewportSize () {
      this.windowWidth = window.innerWidth // Don't remove this. It's used outside the mixin.

      if (window.matchMedia("(min-width: 1280px)").matches) {
        this.currentSize = 'xl'
      } else if (window.matchMedia("(min-width: 1024px)").matches) {
        this.currentSize = 'lg'
      } else if (window.matchMedia("(min-width: 768px)").matches) {
        this.currentSize = 'md'
      } else if (window.matchMedia("(min-width: 480px)").matches) {
        this.currentSize = 'sm'
      } else if (window.matchMedia("(min-width: 375px)").matches) {
        this.currentSize = 'xs'
      } else {
        this.currentSize = 'xxs'
      }
    }
  }
}
